export default __webpack_public_path__ + "static/media/i055jp.87ddc716.webp";